import type {ReactElement} from 'react';
import {DeviceButton} from '../device-button/device-button';
import {DEVICES} from '@FormMakerReact/layout/form-maker-canvas/form-maker-canvas.types';
import type {DevicePillProps} from './device-pill.types';
import styles from '@FormMakerReact/layout/form-maker-canvas/form-maker-canvas.module.scss';

export function DevicePill({currentDevice, onSelect}: DevicePillProps): ReactElement {
  return (
    <div className={styles.devicePill}>
      {DEVICES.map((device) => (
        <DeviceButton key={device} device={device} isActive={currentDevice === device} onSelect={onSelect} />
      ))}
    </div>
  );
}
